import { css } from '@emotion/css';
import { colors } from '@ajaibid/components';

export const styWrapperUploadPayment = css`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background-color: ${colors.NEUTRAL_2};
  height: 270px;
`;

export const styRowWrapper = css`
  display: flex;
  justify-content: center:
  border-radius: 4px;
  margin: 0;
`;
